<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex md12>

        <v-stepper v-model="e1" vertical class="white elevation-8 stepper-customized pb-0">

          <v-stepper-step step="1" class="w-100" :editable="e1 > 1">
            <v-layout justify-center align-center class="w-100">
              <v-flex :class="{'f1-2em text-light':true, 'md10':e1 == '1', 'md7':e1 > 1}">
                <v-layout row wrap>
                  <v-flex md12 class="f1-5em" :class="{'black--text':e1 == '1'}">
                    Datos
                  </v-flex>
                  <v-flex md12 class="f0-8em grey--text">
                    {{e1 == '1' ? campaign.name : ''}}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex md5 class="k-orange-linear-text f1-5em text-light text-xs-right pr-3" v-if="e1 > 1">
                Completado <v-icon class="k-orange-linear-text pl-2">fas fa-check</v-icon>
              </v-flex>
              <v-flex md2 pl-2 v-if="e1 == '1'">
                <v-btn class="k-orange-linear-underline k-orange-linear-text mt-0 elevation-0 filter-height" outline block large @click="dialogRecharge = !dialogRecharge">
                  RECARGAR DATOS
                </v-btn>
              </v-flex>
            </v-layout>
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-card class="transparent">
              <v-card-text class="white pt-3 pr-3 pb-0 pl-0">
                <template v-if="vars.length > 0">
                  <v-layout row wrap mb-3>
                    <v-flex md8 offset-xs2>
                      <v-layout justify-center align-center>
                        <v-flex md8 class="a-borders mx-2 x-borders-radius">
                          <v-layout row wrap class="pa-2">
                            <v-flex md4 class="text-xs-center pt-2">
                              <v-icon class="k-orange-linear-text f2-5em">fas fa-file</v-icon>
                            </v-flex>
                            <v-flex md8>
                              <v-layout row wrap>
                                <v-flex md12 class="f1-5em">
                                  {{campaignSmy.file_rows}}
                                </v-flex>
                                <v-flex md12 class="f1em">
                                  Filas del archivo
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex md8 class="a-borders mx-2 x-borders-radius">
                          <v-layout row wrap class="pa-2">
                            <v-flex md4 class="text-xs-center pt-2">
                              <v-icon class="k-orange-linear-text f2-5em">fas fa-upload</v-icon>
                            </v-flex>
                            <v-flex md8>
                              <v-layout row wrap>
                                <v-flex md12 class="f1-5em">
                                  {{campaignSmy.load_rows}}
                                </v-flex>
                                <v-flex md12 class="f1em">
                                  Filas cargadas
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <vue-perfect-scrollbar
                    class="confirm-campaign--scrollbar">
                    <v-layout row wrap>
                      <v-flex md12>
                        <v-list>
                          <v-list-tile v-for="(item, i) in vars" :key="i" class="w-100">
                            <v-list-tile-content>
                              <v-layout justify-center align-center class="w-100">
                                <v-flex md8>
                                  {{item.name.toUpperCase()}}
                                </v-flex>
                                <v-flex md3>
                                  <v-chip class="transparent">
                                    <v-icon small class="pr-2 red--text" v-if="item.value > 0 && (item.name === 'nombre' || item.name === 'cuenta' || item.name === 'email' || item.name === 'agency')">fas fa-times</v-icon>
                                    <v-icon small class="pr-2 orange--text" v-else-if="item.value > 0 && (item.name !== 'nombre' || item.name !== 'cuenta' || item.name !== 'email' || item.name !== 'agency')">fas fa-info</v-icon>
                                    <v-icon small class="pr-2 green--text" v-else>fas fa-check</v-icon>
                                    {{item.value > 0 ? `( ${new Intl.NumberFormat('es-VE').format(item.value)} )` : ''}}
                                  </v-chip>
                                </v-flex>
                              </v-layout>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </v-flex>
                    </v-layout>
                  </vue-perfect-scrollbar>
                </template>
                <template v-else>
                  <v-layout justify-center align-center fill-height>
                    <v-flex md12 class="headline k-grey-light-text text-xs-center">
                      <img src="../../assets/img/loader.gif" width="100px"/>
                    </v-flex>
                  </v-layout>
                </template>
                <v-dialog
                  v-model="dialogRecharge"
                  scrollable
                  persistent
                  max-width="600px"
                  transition="dialog-transition"
                >
                  <v-card>
                    <v-toolbar class="k-orange-linear white--text">
                      <v-toolbar-title>Cargar datos a campaña</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text class="my-3 px-5">
                      <v-layout row wrap>
                        <v-flex md12>
                          <input type="file" ref="file" @change="handleFileUpload()">
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                    <v-card-actions>
                      <v-container fluid pa-0>
                        <v-layout row wrap>
                          <v-flex md12 text-xs-right>
                            <v-btn color="black" flat @click="dialogRecharge = !dialogRecharge">CANCELAR</v-btn>
                            <v-btn class="k-orange-linear-text" flat @click="rechargeData($route.params.campaign)">GUARDAR</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-card-text>
              <v-card-actions class="white px-0 mr-2" v-if="vars.length > 0">
                <v-layout row wrap class="px-0">
                  <v-flex md12 text-xs-right>
                    <v-btn flat color="black" large @click="$router.push('/campaigns')">CANCELAR</v-btn>
                    <v-btn class="k-orange-linear white--text elevation-1" large @click="confirmData" :disabled="campaignSmy.load_rows === 0">SIGUIENTE</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
          <v-stepper-step step="2" class="w-100" :editable="e1 > 2">
            <v-layout justify-center align-center class="w-100">
              <v-flex :class="{'f1-2em text-light':true, 'md7':e1 == 2, 'md7':e1 > 2}">
                <v-layout row wrap>
                  <v-flex md12 class="f1-5em" :class="{'black--text':e1 == '2'}">
                    {{ campaign.channel === 'human' ? 'Plantilla de reenvio SMS al final del dia' : 'Plantilla' }}
                  </v-flex>
                  <v-flex md12 class="f0-8em grey--text">
                    {{e1 == '2' ? campaign.name : ''}}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex md5 class="k-orange-linear-text f1-5em text-light text-xs-right pr-3" v-if="e1 > 2">
                Completado <v-icon class="k-orange-linear-text pl-2">fas fa-check</v-icon>
              </v-flex>
              <v-flex md5 pl-2 v-if="e1 == '2'">
                <v-select
                v-model="template"
                :items="templates"
                item-text="name"
                return-object
                v-validate="'required'"
                data-vv-name="template_id"
                data-vv-as="plantilla"
                :error-messages="errors.collect('template_id')"
                label="Plantilla de campaña"
                class="a-borders elevation-0"
                color="grey"
                solo>
                </v-select>
              </v-flex>
            </v-layout>
          </v-stepper-step>
          <v-stepper-content step="2">
            <template v-if="templates.length > 0">
              <v-card class="transparent" v-if="template.status === 'activo' | template.status === 'Activo'">
                <v-card-text class="white">
                  <div class="ml-3 pt-3 custom-text h-2" v-html="formatedText(template.text ? template.text : '')" v-if="campaign.channel == 'email'">
                  </div>
                  <div class="ml-3 pt-3 f1-2em italic" v-if="campaign.channel == 'sms' || campaign.channel == 'human'" v-html="formatedText(template[campaign.channel === 'human' ? 'sms' : campaign.channel] ? template[campaign.channel === 'human' ? 'sms' : campaign.channel] : '', campaign.channel)"></div>
                  <template v-if="campaign.channel === 'bot'">
                    <div class="f1-5em text-xs-center my-3">
                      {{`De click a siguiente si el flujo de bot ${template.name} es el que desea enviar`}}
                    </div>
                  </template>
                  <template v-if="campaign.channel === 'ivr'">
                    <div class="f1-5em text-xs-center my-3">
                      {{`De click a siguiente si el flujo de ivr ${template.name} es el que desea enviar`}}
                    </div>
                  </template>
                </v-card-text>
                <v-card-actions class="white px-0 mr-2">
                  <v-layout row wrap class="px-0">
                    <v-flex md12 text-xs-right>
                      <v-btn flat large @click="$router.push('/campaigns')">CANCELAR</v-btn>
                      <v-btn class="k-orange-linear white--text" large @click="confirmCampaign">SIGUIENTE</v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </template>
            <template v-else>
              <v-card class="transparent" height="200px">
                <v-card-text fill-height>
                  <v-layout justify-center align-center fill-height>
                    <v-flex md11 class="f1-4em text-xs-center">
                      <v-icon>fas fa-info-circle</v-icon>
                      No hay plantillas activas o no existen plantillas para este canal
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions class="white px-0 mr-2 mt-4">
                  <v-layout row wrap class="px-0">
                    <v-flex md12 text-xs-right>
                      <v-btn flat large @click="$router.push('/campaigns')">CANCELAR</v-btn>
                      <v-btn class="k-orange-linear white--text" large :disabled="true">SIGUIENTE</v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </template>
          </v-stepper-content>
          <v-stepper-step step="3" class="w-100">
            <v-layout justify-center align-center class="w-100">
              <v-flex :class="{'f1-2em text-light md12':true}">
                <v-layout row wrap>
                  <v-flex md12 class="f1-5em" :class="{'black--text':e1 == '3'}">
                    Opción de entrega
                  </v-flex>
                  <v-flex md12 class="f0-8em grey--text">
                    {{e1 == '3' ? campaign.name : ''}}
                  </v-flex>
                </v-layout>
              </v-flex>
              <!-- <v-flex md4 v-if="e1 == '3'">
                <v-select
                  :items="deliveryOptions"
                  v-model="form.delivery_option"
                  color="grey"
                  item-text="name"
                  item-value="value"
                  class="a-borders elevation-0"
                  label=""
                  solo
                ></v-select>
              </v-flex> -->
            </v-layout>
          </v-stepper-step>
          <v-stepper-content step="3">
            <v-card class="transparent">
              <v-card-text class="white pt-3 pr-3 pb-3 pl-0 elevation-0">
                <v-layout row wrap>
                  <v-flex md6 px-4>
                    <v-layout row wrap>
                      <v-flex md12 px-1 v-for="option in deliveryOptions" :key="`${option.value}_option`">
                        <v-btn block round large :disabled="option.disabled" :outline="option.value !== form.delivery_option" :class="{'k-orange-linear white--text':option.value === form.delivery_option, 'k-orange-linear-underline k-orange-linear-text elevation-0':option.value !== form.delivery_option}" @click="form.delivery_option = option.value">
                          <v-icon small class="pr-2">{{option.icon}}</v-icon> {{option.name}}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md12>
                        <div class="accordion-content">
                          <v-divider v-if="form.delivery_option === 'Agendada'" class="white"></v-divider>
                          <v-layout row wrap :class="{'content':true, 'open':form.delivery_option === 'Agendada', 'close':form.delivery_option !== 'Agendada'}">
                            <v-flex md6 pr-2>
                              <v-menu
                                ref="date"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="form.start_date"
                                transition="scale-transition"
                                min-width="290px"
                                lazy
                                offset-y
                                full-width>
                                <v-text-field
                                  slot="activator"
                                  v-model="formatedStartDate"
                                  color="grey"
                                  append-icon="event"
                                  label="Inicio de campaña"
                                  readonly>
                                </v-text-field>
                                <v-date-picker
                                  v-model="form.start_date"
                                  @input="$refs.date.save(form.start_date)"
                                  locale="es"
                                  color="k-orange-linear">
                                </v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex md6 pl-2>
                              <v-menu
                                ref="time"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="form.start_hour"
                                transition="scale-transition"
                                min-width="290px"
                                lazy
                                offset-y
                                full-width>
                                <v-text-field
                                  slot="activator"
                                  v-model="formatedStartHour"
                                  color="grey"
                                  append-icon="fas fa-clock"
                                  label="Horario de inicio"
                                  readonly>
                                </v-text-field>
                                <v-time-picker
                                  v-model="form.start_hour"
                                  @input="$refs.time.save(form.start_hour)"
                                  locale="es"
                                  color="k-orange-linear">
                                </v-time-picker>
                              </v-menu>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex md6>
                    <div class="a-borders">
                      <v-layout justify-center align-center pl-4>
                        <v-flex md3 class="top-4 k-orange-linear text-xs-center pb-5 pt-5">
                          <v-icon class="white--text" large>fas fa-flag</v-icon>
                        </v-flex>
                        <v-flex md9>
                          <v-layout justify-start align-center px-3 pt-2>
                            <v-flex md12>
                              <v-layout row wrap>
                                <v-flex md12 class="f1-2em">
                                  {{campaign ? campaign.name : ''}}
                                </v-flex>
                                <v-flex md12 class="f0-9em k-grey-text">
                                  {{template.status === 'activo' ? template.name : ''}}
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center align-center pb-2 pt-2 pl-3>
                            <v-flex md12>
                              <v-layout row wrap>
                                <v-flex md12 class="f1-1em">
                                  Fecha de incio
                                </v-flex>
                                <v-flex md12 class="f0-9em k-grey-text">
                                  {{campaign.delivery_option ? campaign.delivery_option === 'Inmediata' ? formatDate(new Date(), 'YYYY-MM-DD', 'DD/MM/YYYY') : formatDate(form.start_date ? form.start_date : new Date(), 'YYYY-MM-DD', 'DD/MM/YYYY') : formatDate(new Date(), 'YYYY-MM-DD', 'DD/MM/YYYY') }}
                                  {{campaign.delivery_option ? campaign.delivery_option === 'Inmediata' ? formatDate(new Date(), 'H:mm', 'h:mm A') : formatDate(form.start_hour ? form.start_hour : new Date(), 'H:mm', 'h:mm A') : formatDate(new Date(), 'H:mm', 'h:mm A') }}
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions class="white px-0 pb-4 mr-5">
                <v-layout row wrap class="px-0">
                  <v-flex md12 text-xs-right>
                    <v-btn flat color="black" large @click="$router.push('/campaigns')">CANCELAR</v-btn>
                    <v-btn class="k-orange-linear white--text" large @click="confirmDeliveryOption">SIGUIENTE</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

        </v-stepper>

      </v-flex>
    </v-layout>
    <v-dialog
      v-model="alertDialog"
      max-width="400px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-text>
          <v-layout justify-center align-center py-2>
            <v-flex md3 text-xs-center>
              <v-icon class="red--text">fas fa-info-circle</v-icon>
            </v-flex>
            <v-flex md9 class="red--text">
              {{text}}
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from 'vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import EventBus from '@/event-bus';
import moment from 'moment';
import DataTable from '@/components/global/DataTable';
import campaignVarLists from '@/components/campaign_var/CampaignVarList';

Vue.component('campaignVarLists', campaignVarLists);

export default {
  inject: ['$validator'],
  components: {
    DataTable,
    VuePerfectScrollbar,
  },
  data() {
    return {
      filters: {
        search: '',
        status: '',
      },
      e1: 1,
      campaign: {
        name: '',
      },
      campaignSmy: {},
      campaignVar: {},
      vars: [],
      statuses: [
        {
          value: '',
          name: 'Estados',
        },
        {
          value: 'valido',
          name: 'Valido',
        },
        {
          value: 'invalido',
          name: 'Invalido',
        },
      ],
      template: {},
      templates: [],
      dialogRecharge: false,
      dialogTest: false,
      dialogOption: false,
      file: '',
      form: {
        to: '',
        delivery_option: 'Inmediata',
      },
      deliveryOptions: [
        {
          value: 'Inmediata',
          disabled: false,
          name: 'Inmediata',
          icon: 'fas fa-calendar-alt',
        },
      ],
      status: {},
      alertDialog: false,
      text: '',
    };
  },
  created() {
    this.updateCharge();
  },
  mounted() {
    this.getCampaignSmyAndVar();
    EventBus.$on('update', () => {
      this.getCampaign();
    });
    this.getCampaign(2);
  },
  computed: {
    formatedStartDate() {
      return this.form.start_date ? moment(this.form.start_date, 'YYYY-MM-DD').format('DD/MM/YYYY') : '';
    },
    formatedStartHour() {
      return this.form.start_date && this.form.start_hour ? moment(`${this.form.start_date} ${this.form.start_hour}:00`, 'YYYY-MM-DD H:mm A').format('h:mm A') : '';
    },
  },
  destroyed() {
    EventBus.$off('update');
    EventBus.$off('modal');
    this.stopListeningEvents();
  },
  methods: {
    /* eslint-disable */
    stopListeningEvents() {
      window.Echo.leave(`campaign.${this.$route.params.campaign}`);
    },
    updateCharge() {
      window.Echo.channel(`campaign.${this.$route.params.campaign}`).listen('.failedUpload', (event) => {
        if (event.upload === 'failed') {
          this.text = event.message;
          this.alertDialog = true;
        } else {
          this.getCampaignSmyAndVar();
        }
      });
    },
    formatedText(originalText, channel) {
      let text = originalText;
      let textVars = {
        first_name: 'nombre',
        last_name: 'apellido',
        account: 'cuenta',
        c_to: channel === 'email' ? 'email' : 'telefono',
        send_date: 'fecha_envio',
      };
      for (let i = 15; i >= 1; i -= 1) {
        const value = `var_${i}`;
        textVars[value] = value;
      }
      textVars.var_2 = 'monto';

      const varsToReplace = _.pick(this.campaignVar, Object.keys(textVars));

      Object.keys(varsToReplace).forEach((key) => {
        let value = varsToReplace[key] || '';
        const isDate = moment(value, 'YYYY-MM-DD', true).isValid();
        if (isDate) {
          value = moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY');
        }
        text = text.replace(new RegExp(`@${textVars[key]}`, 'g'), value);
      });
      return text;
    },
    /* eslint-enable */
    confirmData() {
      this.e1 = 2;
    },
    confirmCampaign() {
      this.axios.patch(`/campaigns/${this.$route.params.campaign}`, {
        template_id: this.form.template_id,
      }).then(() => {
        this.e1 = 3;
        EventBus.$emit('update');
      }).catch((e) => {
        EventBus.$emit('modal', e.response.data);
      });
    },
    getCampaignSmyAndVar() {
      if (this.vars.length === 0) {
        this.axios.get(`/campaigns/${this.$route.params.campaign}/campaign_smy`).then((response) => {
          this.campaignSmy = response.data;
          if (response.data.load_rows === 0) {
            EventBus.$emit('modal', 'Revise el archivo porque no se han cargado datos!');
          } else {
            EventBus.$emit('modal', `Se eliminaron un ${Math.round(((response.data.file_rows - response.data.load_rows) / response.data.file_rows) * 100)}% de las filas del archivo`);
          }
          this.vars = Object.keys(response.data.var_table).map((key) => {
            const o = {
              name: '',
              value: 0,
            };
            o.name = key;
            o.value = response.data.var_table[key].nulls;
            return o;
          });
        });
        this.axios.get(`/campaigns/${this.$route.params.campaign}/campaign_var`).then((response) => {
          this.campaignVar = response.data;
        });
      }
    },
    getCampaign(number = null) {
      if (number != null) {
        this.e1 = number;
      }
      /* eslint-disable */
      this.axios.get(`/campaigns/${this.$route.params.campaign}?fields=channel,template_id,name,start_date,delivery_option,status`).then((response) => {
        this.campaign = response.data;
        if (this.campaign.channel === 'email' || this.campaign.channel === 'sms' || this.campaign.channel === 'human') {
          this.axios.get(`/templates?type=campaign&paginate=0&notNull=${this.campaign.channel}&diff=template_code&diff-value=000`).then((resp) => {
            if (resp.data.length > 0) {
              this.campaign.template_id ? this.template = resp.data.find(o => o.id === this.campaign.template_id) : this.template = resp.data[0];
              this.templates = resp.data;
            }
          });
        } else if(this.campaign.channel === 'bot') {
          this.axios.get(`/bot_templates?fields=name,status,id,botTemplateDetails.name,botTemplateDetails.text&paginate=0`).then((resp) => {
            if (resp.data.length > 0) {
              this.campaign.template_id ? this.template = resp.data.find(o => o.id === this.campaign.template_id) : this.template = resp.data[0];
              this.templates = resp.data;
            }
          });
        } else {
          this.axios.get(`/ivr_templates`).then((resp) => {
            if (resp.data.items) {
              const items = resp.data.items.map(el => ({
                ...el.status_id === 1 && {
                  status: 'Activo',
                },
                ...el,
              }))
              this.campaign.template_id ? this.template = items.find(o => o.id === this.campaign.template_id) : this.template = items[0];
              this.templates = items;
            }
          });
        }
        //this.campaignSmyAndVar();
      }).catch(() => { });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    rechargeData(id) {
      const formData = new FormData();
      formData.append('file', this.file);
      this.axios.post(`/campaigns/${id}/recharge`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(() => {
        this.vars = [];
        this.dialogRecharge = false;
        EventBus.$emit('update');
      }).catch((e) => {
        EventBus.$emit('modal', e.response.data);
      });
    },
    confirmDeliveryOption() {
      if (this.form.delivery_option === 'Agendada') {
        this.axios.patch(`/campaigns/${this.$route.params.campaign}`, {
          delivery_option: this.form.delivery_option,
          start_date: this.form.start_date ? this.form.start_date : '',
          start_hour: this.form.start_hour ? moment(`${this.form.start_date} ${this.form.start_hour}:00`).local().utc().format('HH:mm') : '',
          status: 'Confirmada',
        }).then(() => {
          this.$router.push(`/campaigns`);
        }).catch((e) => {
          EventBus.$emit('modal', e.response.data);
        });
      } else {
        this.axios.patch(`/campaigns/${this.$route.params.campaign}`, {
          delivery_option: this.form.delivery_option,
          status: 'Confirmada',
        }).then(() => {
          this.$router.push(`/campaigns`);
        }).catch((e) => {
          EventBus.$emit('modal', e.response.data);
        });
      }
    },
    formatDate(date, typeDate, toFormat) { // eslint-disable-line
      return moment(date, typeDate).format(toFormat);
    },
  },
  watch: {
    template(val) {
      if (val) {
        this.form.template_id = val.id;
      }
    },
    form: {
      handler(val) {
        this.campaign.delivery_option = val.delivery_option;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.confirm-campaign--scrollbar > div {
    height:280px !important;
}

.accordion-content {
  height:auto;
}
.accordion-content .content {
  display:none;
  position: relative;
  transition-property:display;
  transition-duration: 5s !important;
}
.accordion-content .content.open {
  display:flex;
  -webkit-animation-name: open; /* Safari 4.0 - 8.0 */
  -webkit-animation-duration: 0.3s; /* Safari 4.0 - 8.0 */
  animation-name: open;
  animation-duration: 0.3s;
}
.accordion-content .content.close {
  -webkit-animation-name: close; /* Safari 4.0 - 8.0 */
  -webkit-animation-duration: 0.3s; /* Safari 4.0 - 8.0 */
  animation-name: close;
  animation-duration: 0.3s;
  display:none;
}

.animate-first-pointer {
  animation: firstPointer 1s linear infinite;
}

.animate-second-pointer {
  animation: secondPointer 2s linear infinite;
}

.animate-third-pointer {
  animation: thirdPointer 3s linear infinite;
}

.vertical-divider-template-50 {
  height: 50px !important;
  width: 50% !important;
  border-left-color: rgba(0, 0, 0, 0.4) !important;
  border-left-width: 1px !important;
  border-top-width: 2px !important;
  margin-left: 25% !important;
}

.vertical-divider-template-100 {
  height: 160px !important;
  width: 50% !important;
  border-left-color: rgba(0, 0, 0, 0.4) !important;
  border-left-width: 1px !important;
  margin-left: 25% !important;
}

.vertical-divider {
  height: 100px !important;
  width: 50% !important;
  border-left-color: rgba(0, 0, 0, 0.4) !important;
  border-left-width: 2px !important;
  margin-left: 50% !important;
}

@-webkit-keyframes firstPointer {
  50% {
    opacity: 0;
  }
}

@keyframes firstPointer {
  50% {
    opacity: 0;
  }
}

@-webkit-keyframes secondPointer {
  50% {
    opacity: 0;
  }
}

@keyframes secondPointer {
  50% {
    opacity: 0;
  }
}

@-webkit-keyframes thirdPointer {
  50% {
    opacity: 0;
  }
}

@keyframes thirdPointer {
  50% {
    opacity: 0;
  }
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes close {
  from {opacity:1;}
  to {opacity:0;}
}

/* Standard syntax */
@keyframes close {
  from {opacity:1;}
  to {opacity:0;}
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes open {
  from {opacity:0;}
  to {opacity:1;}
}

/* Standard syntax */
@keyframes open {
  from {opacity:0;}
  to {opacity:1;}
}
</style>



// WEBPACK FOOTER //
// src/components/campaign/CampaignConfirm.vue